<script setup>
import { useBgBlurState, useScopedBgBlurState } from "../blurState";

const props = defineProps({
  scope: {
    type: String,
    required: false,
    default: undefined,
  },
});

let scope = props.scope;
if (scope === undefined) {
  // if url contains scope, use it
  const urlParams = new URLSearchParams(window.location.search);
  scope = urlParams.get("agentPreviewScope");
}

const bgBlurState = scope ? useScopedBgBlurState(scope) : useBgBlurState();

const backgroundQualityOptions = [
  {
    title: "Medium",
    value: "medium",
  },
  {
    title: "High",
    value: "high",
  },
];
</script>

<template>
  <v-window-item value="backgroundSettings" v-if="bgBlurState.backgroundActive">
    <v-card>
      <v-card-title style="display: flex; flex-direction: row; align-content: center; align-items: center">
        <v-icon>mdi-blur</v-icon>
        <span style="margin-left: 10px">{{ $t("BackgroundSettings") }}</span>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent>
          <v-row>
            <v-col cols="6" v-if="bgBlurState.backgroundActive">
              <v-select :items="backgroundQualityOptions" v-model="bgBlurState.quality"></v-select>
            </v-col>
            <v-col cols="6" v-if="bgBlurState.backgroundActive && bgBlurState.backgroundPipeline === 'webgl2'">
              <v-slider
                v-model="bgBlurState.sigmaSpace"
                :label="$t('BackgroundSigmaSpace') + ' (' + bgBlurState.sigmaSpace.toFixed(1) + ')'"
                min="0"
                max="10"
                step="0.1"></v-slider>
            </v-col>
            <v-col cols="6" v-if="bgBlurState.backgroundActive && bgBlurState.backgroundPipeline === 'webgl2'">
              <v-slider
                v-model="bgBlurState.coverageMin"
                :label="$t('CoverageMin') + ' (' + bgBlurState.coverageMin.toFixed(2) + ')'"
                min="0"
                max="1"
                step="0.01"></v-slider>
            </v-col>
            <v-col cols="6" v-if="bgBlurState.backgroundActive && bgBlurState.backgroundPipeline === 'webgl2'">
              <v-slider
                v-model="bgBlurState.coverageMax"
                :label="$t('CoverageMax') + ' (' + bgBlurState.coverageMax.toFixed(2) + ')'"
                min="0"
                max="1"
                step="0.01"></v-slider>
            </v-col>
            <v-col cols="6" v-if="bgBlurState.backgroundActive && bgBlurState.backgroundPipeline === 'webgl2'">
              <v-slider
                v-model="bgBlurState.lightWrapping"
                :label="$t('LightWrapping') + ' (' + bgBlurState.lightWrapping.toFixed(2) + ')'"
                min="0"
                max="1"
                step="0.01"></v-slider>
            </v-col>
            <v-col cols="6" v-if="bgBlurState.backgroundActive && bgBlurState.backgroundPipeline === 'webgl2'">
              <v-btn @click="bgBlurState.clearBgBlurState" color="primary">{{ $t("ResetValues") }}</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-window-item>
</template>
